import { Box, Title } from '@nimbus-ds/components';
import { OnboardingTask } from '@tiendanube/common';
import { useNavegate } from 'App/hooks';
import { trackingRecommendationClick } from 'App/tracking';
import { openWindow } from 'commons/utils/window';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import dashboardService from 'domains/Dashboard/services';
import OnboardingPromoteTasks from '../OnboardingPromoteTasks';

interface RecommendationsListProps {
  tasks: OnboardingTask[];
}

export function RecommendationsList({ tasks }: RecommendationsListProps) {
  const t = useTranslationDashboard();
  const { goTo } = useNavegate();

  if (tasks.length === 0) return null;

  const handleConnect = async (task: OnboardingTask) => {
    trackingRecommendationClick(task.name);
    if (task?.onCtaLinkClickComplete) {
      await dashboardService.updateOnboardingTaskStatus({
        task: task.name,
        status: 'completed',
      });
    }
    if (task.ctaExternal) {
      openWindow(task.ctaLink, true);
    } else {
      goTo(task.ctaLink);
    }
  };

  return (
    <Box display="flex" flexDirection="column" gap="4">
      <Title as="h5" fontWeight="regular">
        {t('promote.recommendations')}
      </Title>
      <OnboardingPromoteTasks
        tasks={tasks}
        onAction={handleConnect}
        type="recommendation"
      />
    </Box>
  );
}

export default RecommendationsList;
